<template>
  <div class="content">
    <SchemaTree
      ref="SchemaTree"
      class="tree"
      :treedata="treeData"
      @changeNode="changeNode"
    ></SchemaTree>
    <ChooseList
      :height="height"
      :saved.sync="saved"
      :params.sync="params"
      :carrierList="searchList.length || searchMode ? searchList : carrierList"
      :page.sync="page"
      class="choose-list"
      @search="search"
      @loadMore="getMore"
      :disableLoad="isNoMore"
    ></ChooseList>
    <!-- <el-button style="position:absolute; bottom:2px;left:2px;right:2px" @click="getMore">{{ isNoMore ? $t('integration.no_more') : $t('integration.click_to_see_more') }} </el-button> -->
  </div>
</template>

<script>
import elementResizeDetectorMaker from 'element-resize-detector'
import ChooseList from './component/ChooseList.vue'
import SchemaTree from './component/SchemaTree.vue'
import bus from '@/utils/bus'
import { defaultPath } from './config/default'

export default {
  // 用于区分不同的tab  获取已选中的接口不同
  props: {
    // 获取列表接口
    getList: {
      type: Function
    },
    // 获取保存
    // 如果为Function类型（Function必须返回Promise） 则会从Function中获取所有已保存监测点点
    // 如果是String类型 则意味着getList接口已经返回了保存的监测点点 会根据String类型的路径查找数据
    // 如果是Array类型  则是直接提供已保存监测点点数组
    getSave: {
      type: [Function, String, Array]
    },
    // 列表的路径 按照表达式的形式来写result
    path: {
      type: Object,
      default: () => {
        // 由于后端返回的路径都不一致  这里对路径做传参兼容处理  这里的值会自动覆盖
        return defaultPath
      }
    },
    // 加一个props,不影响原来的逻辑
    getArrFlag:{
      type: Boolean,
      default: false
    }
  },
  components: {
    SchemaTree,
    ChooseList
  },
  data () {
    return {
      carrierList: [],
      // 获取列表的参数
      params: {
        iDisplayStart: 0,
        iDisplayLength: 20,
        sceneId: null,
        status: null,
        carrierName: null,
        carrierType: null
      },
      // 树的数据 需要剔除第一个
      treeData: [],
      // 得到剩余高度
      height: '0px',
      // 传入子组件的页码
      page: 0,
      // 搜索结果  这里考虑采用将搜索和列表展示分别独立
      searchList: [],
      flag: false,
      // 已选中的监测点
      saved: [],
      searchMode: false,
      // 没有更多了
      isNoMore: false
    }
  },
  watch: {
    // 当子组件页码被改变
    page (newVal) {
      this.params.iDisplayStart = this.params.iDisplayLength * this.page
    },
    params () {
      if (
        !this.params.status &&
        !this.params.carrierName &&
        !this.params.carrierType
      ) {
        this.searchMode = false
      } else {
        this.searchMode = true
      }
    }
  },
  mounted () {
    const pathObj = { ...defaultPath, ...this.path }
    Object.keys(pathObj).forEach(key => {
      this.path[key] = pathObj[key]
    })

    this.initTree()
    this.getListFn({ mounted: true })
    this.getSaveFn()
    const erd = elementResizeDetectorMaker()
    // this.$nextTick(() => {
    // console.log(this.$refs.SchemaTree.$el.offsetHeight);
    erd.listenTo(this.$refs.SchemaTree.$el, element => {
      const treeHeight = element.offsetHeight
      this.height = `calc(100% - ${treeHeight}px)`
    })
    // })
    // 事件总线  数据分析右侧未选中任何监测点 则向右侧图表发送所有监测点信息
    bus.$on('sendCarrierList', () => {
      bus.$emit('saveMonitorPoint', this.carrierList)
    })
  },
  methods: {
    // 由于后端返回的路径不一  这里尝试对传入的路径做访问
    readPath (res, path) {
      let cur = res
      const pathArr = path.split('.')
      pathArr.forEach(p => {
        cur = cur[p]
      })
      return cur
    },
    // 参数默认为非首次加载
    getListFn (param = { mounted: false }) {
      this.getList(this.params).then(res => {
        this.carrierList = this.readPath(res, this.path.listPath)
        if (typeof this.getSave === 'string' && param.mounted === true) {
          const saved = this.readPath(res, this.getSave)
          // 保存的监测点点理应是一个数组 如果是数组才进行赋值
          if (saved instanceof Array) {
            this.saved = saved
            bus.$emit('selectRows', saved)
          }
        }
      })
    },
    // 获取更多
    getMore () {
      if (this.isNoMore) return
      ++this.page
      this.$nextTick(() => {
        this.getList(this.params).then(result => {
          const res = result.result;
          console.log('getMore-> ',res);
          const pageInfo = this.readPath(res, this.path.pagePath)
          this.carrierList = this.carrierList.concat(
            this.readPath(res, this.path.listPath)
          )

          if (
            this.carrierList.length === pageInfo.total &&
            this.params.iDisplayStart !== 0
          ) {
            this.isNoMore = true
            return this.$message.warning($t('integration.no_more'))
          } else {
            this.isNoMore = false
          }
        })
      })
    },
    getSaveFn () {
      if (typeof this.getSave === 'function') {
        this.getSave().then(res => {
          this.saved = this.readPath(res, this.path.savePath)
          bus.$emit('selectRows', this.saved)
        })
      } else if (this.getSave instanceof Array) {
        if(this.getArrFlag){
          this.saved = this.getSave
          bus.$emit('selectRows', this.getSave)
        }else{
          this.saved = []
          bus.$emit('selectRows', [])
        }
      }
    },
    handleClick (row) {
      this.allChooze = { ...row }
    },
    changeNode (label) {
      this.params.iDisplayStart = 0

      if (label.sceneId || label.scopeId) {
        if (this.params.sceneId !== label.sceneId) {
          this.page = 0
          this.params.sceneId = label.sceneId || label.scopeId
          this.carrierList = []
          this.getListFn()
        }
      }
    },
    initTree () {
      const tree = JSON.parse(JSON.stringify(this.$store.state.SchemaTree))
      if (tree[0].sceneCode === 'all_node') {
        tree.shift()
      }
      this.treeData = tree
      this.params.sceneId = tree[0].scopeId
    },
    search () {
      // 未指定参数的情况 则展示正常列表
      if (
        !this.params.status &&
        !this.params.carrierName &&
        !this.params.carrierType
      ) {
        this.searchList = []
        const carrierList = this.carrierList

        this.carrierList = carrierList

        return
      }
      this.getList(this.params).then(res => {
        // const res=result.page.result;
        const pageInfo = this.readPath(res, this.path.pagePath)
        this.searchList = this.readPath(res, this.path.listPath)
        if (
          this.carrierList.length === pageInfo.total &&
          this.params.iDisplayStart !== 0
        ) {
          return this.$message.warning($t('integration.no_more'))
        }
      })
    },
    // 加载更多
    loadMore () {}
  },
  beforeDestroy () {
    bus.$off('sendCarrierList')
  }
}
</script>

<style lang="scss" scoped>
.content {
  .tree {
    height: auto;
    max-height: 50%;
    width: 100%;
  }

  height: 100%;
  width: 300px;
  border: 1px solid #cccccc;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;

  // .choose-list {
  //     max-height: 50%;

  // }
}
</style>
